import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNintendonetworkComponent } from './simple-icons-nintendonetwork.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNintendonetworkComponent ],
    exports:      [ SimpleIconsNintendonetworkComponent ],
    bootstrap:    []
})
export class SimpleIconsNintendonetworkModule {}
